export const AutoClearMyMeetingActions = 30000;
